import { render, staticRenderFns } from "./CascoInsuranceCalculator.vue?vue&type=template&id=28b1839a"
import script from "./CascoInsuranceCalculator.vue?vue&type=script&lang=ts"
export * from "./CascoInsuranceCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports